/* EVS 2026-07-31 — clamped preview for product tabs opened by default */
class EvsClamp extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('.evs-clamp__content');
    this.button = this.querySelector('.evs-clamp__toggle');
    if (!this.content || !this.button) return;
    this.label = this.button.querySelector('.evs-clamp__label');
    this.button.addEventListener('click', () => this.setExpanded(!this.isExpanded));
    this.setExpanded(false);
    this.measure();
    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.content);
    }
    window.addEventListener('resize', this.measure.bind(this));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.measure());
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  get maxHeight() {
    const v = parseInt(getComputedStyle(this).getPropertyValue('--evs-clamp-h'), 10);
    return isNaN(v) ? 240 : v;
  }

  measure() {
    if (!this.content) return;
    const overflows = this.content.scrollHeight > this.maxHeight + 8;
    this.classList.toggle('is-clampable', overflows);
    this.button.hidden = !overflows;
    if (!overflows && this.isExpanded) this.setExpanded(false);
  }

  setExpanded(expanded) {
    this.isExpanded = !!expanded;
    this.classList.toggle('is-expanded', this.isExpanded);
    this.button.setAttribute('aria-expanded', String(this.isExpanded));
    if (this.label) {
      const next = this.label.dataset[this.isExpanded ? 'less' : 'more'];
      if (next) this.label.textContent = next;
    }
  }
}

if (!customElements.get('evs-clamp')) customElements.define('evs-clamp', EvsClamp);
